/* Night guard store helpers — scoped, no dependency on Shrine's external main.js.
   1) [data-ns-scroll="buy"] buttons smooth-scroll to the purchase area
      (PDP: #ProductInfo-<section id>; homepage: the featured-product section).
   2) [data-ns-carousel] scroll-snap tracks get working prev/next arrows that wrap around. */
(function () {
  if (window.__nsInit) return; window.__nsInit = true;
  function buyTarget() {
    return document.querySelector('[id^="ProductInfo-"]') ||
      document.querySelector('[id$="__buy"]') ||
      document.querySelector('product-form') ||
      document.querySelector('.featured-product');
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-ns-scroll]');
    if (btn) {
      var t = buyTarget();
      if (t) {
        e.preventDefault();
        var header = document.querySelector('sticky-header, .section-header');
        var off = header ? Math.min(header.offsetHeight, 120) : 0;
        var y = t.getBoundingClientRect().top + window.pageYOffset - off - 12;
        window.scrollTo({ top: y, behavior: 'smooth' });
      }
      return;
    }
    var arrow = e.target.closest('[data-ns-prev],[data-ns-next]');
    if (arrow) {
      var root = arrow.closest('[data-ns-carousel]');
      var track = root && root.querySelector('.ns-track');
      if (!track) return;
      var card = track.firstElementChild;
      var step = card ? card.getBoundingClientRect().width + 14 : track.clientWidth * 0.8;
      var max = track.scrollWidth - track.clientWidth - 2;
      if (arrow.hasAttribute('data-ns-next')) {
        track.scrollTo({ left: track.scrollLeft >= max ? 0 : track.scrollLeft + step, behavior: 'smooth' });
      } else {
        track.scrollTo({ left: track.scrollLeft <= 2 ? max : track.scrollLeft - step, behavior: 'smooth' });
      }
    }
  });
})();
